import type { ToastItem } from '../../../../stores/toastStore';
import { useTranslation } from '../../../../i18n/useTranslation';
import './Toast.css';

export type { ToastItem };

export interface ToastProps {
  toast: ToastItem;
  onDismiss: (id: string) => void;
}

const ICONS: Record<ToastItem['type'], string> = {
  success: '✓',
  error: '✕',
  loading: '⟳',
  info: 'ℹ',
};

export function Toast({ toast, onDismiss }: ToastProps) {
  const { t } = useTranslation();
  const { id, message, type } = toast;

  return (
    <div
      className={`toast toast--${type}`}
      role="alert"
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
      data-testid={`toast-${id}`}
    >
      <span className="toast__icon" aria-hidden="true">
        {ICONS[type]}
      </span>
      <span className="toast__message">{message}</span>
      {type !== 'loading' && (
        <button
          type="button"
          className="toast__dismiss"
          aria-label={t('common.dismissNotification')}
          onClick={() => onDismiss(id)}
        >
          ✕
        </button>
      )}
    </div>
  );
}
